import { APPWRITE_CLOUD_ENDPOINT_URL, getAppwriteRunEndpointUrl, LOCALHOST_BASE_URL, LOOPBACK_BASE_URL } from './links';

export const ENDPOINT_ID: string =
    process.env.NODE_ENV === 'production' ? '689dff21001ce823602d' : '689dffee002415682ac0';
export const PROJECT_ID: string =
    process.env.NODE_ENV === 'production' ? '689dfebe003931214c2b' : '689dfea900213218f7c6';
export const ORIGIN: string = process.env.NODE_ENV === 'production' ? LOOPBACK_BASE_URL : LOCALHOST_BASE_URL;
export const PROJECT_ENDPOINT: string = APPWRITE_CLOUD_ENDPOINT_URL;
export const APPWRITE_API: string = getAppwriteRunEndpointUrl(ENDPOINT_ID);
